import _ from 'lodash';

function getErrorMsg(errorData) {
    return _.isObject(errorData) ? (errorData.message || errorData.error || errorData.msg) : errorData;
}

export default getErrorMsg;
